import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const AccordionHeadWrapper = styled(FlexRow)`
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const TitleContainer = styled(FlexRow)`
    align-items: center;
    max-height: 24px;
`;

export const Title = styled.p<{
    isAccordionOpen: boolean;
}>`
    margin: 2px 12px 0;
    ${({ isAccordionOpen }) =>
        isAccordionOpen
            ? setFontVariant("subtitle2", colorsPalettes.carbon[500])
            : setFontVariant("subtitle2", colorsPalettes.carbon[400])};
`;

export const ProgressBarContainer = styled(FlexRow)`
    align-items: center;
    gap: 16px;
`;

export const ProgressBarLabel = styled.span`
    ${setFontVariant("input2", colorsPalettes.carbon[300])};
`;

export const ShareBarWrapper = styled.div`
    border-radius: 17px;
    overflow: hidden;
    height: 8px;
    width: 116px;
`;
export const ShareBarWrapperForHomePage = styled.div`
    border-radius: 17px;
    overflow: hidden;
    height: 8px;
    width: 129px;
`;

export const NotificationCircle = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50px;
    border: 2px solid ${colorsPalettes.orange[200]};
    background-color: ${colorsPalettes.orange[400]};
`;
